module.exports = __webpack_public_path__ + "img/user.089cd58e.svg";